import FastImage from 'react-native-fast-image';
import {RFValue} from 'react-native-responsive-fontsize';
import styled from 'styled-components/native';
import Ionicons from 'react-native-vector-icons/Ionicons';

export const Container = styled.View`
  flex: 1;

  background-color: ${({theme}) => theme.colors.background};
`;

export const Header = styled.View`
  flex-direction: row;
  justify-content: space-between;
  padding: 0 24px;
`;

export const CardInfo = styled.View``;

export const Brand = styled.Text`
  font-size: ${RFValue(16)}px;
  font-family: ${({theme}) => theme.fonts.semibold};
  color: ${({theme}) => theme.colors.text_dark};
`;

export const Number = styled.Text`
  font-size: ${RFValue(12)}px;
  font-family: ${({theme}) => theme.fonts.regular};
  color: ${({theme}) => theme.colors.text_2};
`;

export const CardBrand = styled.View``;


//@ts-ignore
export const BrandImage = styled(FastImage)`
  width: ${RFValue(30)}px;
  height: ${RFValue(20)}px;
  border: 1px solid ${({theme}) => theme.colors.border2};
  border-radius: ${RFValue(2)}px;
`;

export const Content = styled.View`
  flex: 1;
  margin-top: ${RFValue(12)}px;
`;

export const FeaturesList = styled.View``;

export const FeatureItem = styled.View`
  border-style: solid;
  border-bottom-width: 1px;
  padding: ${RFValue(12)}px 24px;
  border-color: ${({theme}) => theme.colors.border};
  justify-content: center;
`;

export const Label = styled.Text`
  font-size: ${RFValue(12)}px;
  font-family: ${({theme}) => theme.fonts.regular};
  color: ${({theme}) => theme.colors.text};
`;

export const Text = styled.Text`
  font-size: ${RFValue(12)}px;
  font-family: ${({theme}) => theme.fonts.semibold};
  color: ${({theme}) => theme.colors.text_dark};
  margin-top: ${RFValue(2)}px;
`;

export const DeleteCardButton = styled.TouchableOpacity`
  padding: ${RFValue(12)}px 24px;
  flex-direction: row;
  align-items: center;
`;

export const DeleteCardButtonIcon = styled(Ionicons)`
  font-size: ${RFValue(16)}px;
  margin-right: ${RFValue(8)}px;
  color: ${({theme}) => theme.colors.attention};
`;

export const DeleteCardButtonText = styled.Text`
  font-size: ${RFValue(12)}px;
  font-family: ${({theme}) => theme.fonts.medium};
  color: ${({theme}) => theme.colors.attention};
  margin-top: ${RFValue(2)}px;
`;
